import { render, staticRenderFns } from "./newsConsul.vue?vue&type=template&id=14a6b558&scoped=true"
import script from "./newsConsul.vue?vue&type=script&lang=js"
export * from "./newsConsul.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a6b558",
  null
  
)

export default component.exports